import {Route} from '@angular/router';
import {ResourceListComponent} from './resources/resource-list/resource-list.component';
import {ResourceResolver} from './resources/resource.resolver';
import {ManufacturingItemGroupResolver} from './manufactured-item-groups/manufacturing-item-group-resolver.service';
import {ResourceEditStateComponent} from './resources/resource-edit-state/resource-edit-state.component';
import {ManufacturingItemEditStateComponent} from "./manufacturing-item/manufacturing-item-edit-state/manufacturing-item-edit-state.component";
import {ManufacturingItemResolver} from "./manufacturing-item/manufacturing-item.resolver";
import {ManufacturingItemGroupEditStateComponent} from './manufactured-item-groups/manufacturing-item-group-edit-state/manufacturing-item-group-edit-state.component';
import {ProcessListComponent} from "./processes/process-list/process-list.component";
import {ItemListComponent} from "./manufacturing-item/item-list/item-list.component";
import {ItemGroupListComponent} from "./manufactured-item-groups/item-group-list/item-group-list.component";
import {ImeListComponent} from "./ime-list/ime-list.component";

export const ManufacturingRoutes = {
  getResourceRoutes(): Route {
    return {
      path: 'resource', data: {
        breadcrumb: 'Resources'
      }, children: [
        {
          path: '', children: [
            {
              path: '',
              component: ResourceListComponent,
              data: {
                actionbar: false,
                search: {
                  advanced: true,
                  enabled: true
                }
              }
            }
          ]
        },
        {
          path: 'add', children: [
            {
              path: '',
              component: ResourceEditStateComponent,
              data: {actionbar: false}
            }
          ]
        },
        {
          path: 'edit/:id', resolve: {entity: ResourceResolver}, children: [
            {
              path: '',
              component: ResourceEditStateComponent,
              data: {actionbar: false}
            }
          ]
        }
      ]
    };
  },
  getItemRoutes(): Route {
    return {
      path: 'item', data: {
        breadcrumb: 'Items'
      }, children: [
        {
          path: '', children: [
            {
              path: '',
              runGuardsAndResolvers: 'paramsOrQueryParamsChange',
              component: ItemListComponent,
              data: {
                actionbar: false,
                search: {
                  advanced: true,
                  enabled: true
                }
              }
            }
          ]
        },
        {path: 'add', redirectTo: 'add/', pathMatch: 'full'},
        {
          path: 'add/:groupId', children: [
            {
              path: '',
              component: ManufacturingItemEditStateComponent,
              data: {actionbar: false}
            }
          ]
        },
        {
          path: 'edit/:id', redirectTo: 'edit/:id/general', pathMatch: 'full'
        },
        {
          path: 'edit/:id/:tab', resolve: {entity: ManufacturingItemResolver}, children: [
            {
              path: '',
              component: ManufacturingItemEditStateComponent,
              data: {actionbar: false}
            }
          ]
        }
      ]
    };
  },
  getItemTemplates(): Route {
    return {
      path: 'item-template', data: {
        breadcrumb: 'Master Items'
      }, children: [
        {
          path: '', children: [
            {
              path: '',
              component: ItemGroupListComponent,
              data: {
                actionbar: false,
                search: {
                  advanced: true,
                  enabled: true
                }
              }
            }
          ]
        },
        {
          path: 'add', children: [
            {
              path: '',
              component: ManufacturingItemGroupEditStateComponent,
              data: {actionbar: false}
            }
          ]
        },
        {
          path: 'edit/:id', redirectTo: 'edit/:id/general', pathMatch: 'full'
        },
        {
          path: 'edit/:id/:tab', resolve: {entity: ManufacturingItemGroupResolver}, children: [
            {
              path: '',
              component: ManufacturingItemGroupEditStateComponent,
              data: {actionbar: false}
            }
          ]
        }
      ]
    };
  },
  getProcessRoutes(): Route {
    return {
      path: 'process', data: {
        breadcrumb: 'Processes'
      }, children: [
        {
          path: '', children: [
            {
              path: '',
              component: ProcessListComponent,
              data: {
                actionbar: false,
                search: {
                  advanced: false,
                  enabled: true
                }
              }
            }
          ]
        }
      ]
    } as Route;
  },
  getImeListRoute(): Route {
    return {
      path: 'ime', data: {
        breadcrumb: 'IME'
      }, children: [
        {
          path: '',
          children: [
            {
              path: '',
              component: ImeListComponent,
              data: {
                actionbar: false,
                search: {
                  advanced: true,
                  enabled: true
                }
              }
            }
          ]
        }
      ]
    } as Route
  }
};
